export const benefitsData = [
  {
    id: 1,
    benefit: "We provide professional and certified trainers.",
  },
  {
    id: 2,
    benefit: "You can join the community for free.",
  },
  {
    id: 3,
    benefit: "More than 250+ gyms spread all over the world.",
  },
  {
    id: 4,
    benefit: "You can consult to our trainers for free.",
  },
  {
    id: 5,
    benefit: "We provide affordable gyms at affordable prices.",
  },
];
